export default __webpack_public_path__ + "static/media/icon-error-check-mark-assignment.fc60bfde.svg";